import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const SocialProofSection = () => {
  const awards = [
    {
      title: "Premio 1",
      year: "2010",
      description: "Por ser buena escribiendo"
    },
    {
      title: "Premio 2",
      year: "2018",
      description: "Por ser buena escribiendo"
    },
    {
      title: "Premio 3",
      year: "2019",
      description: "Por que es lo máximo"
    }
  ];

  const stats = [
    {
      number: "250k+",
      label: "Libros vendidos mundialmente",
      icon: "BookOpen"
    },
    {
      number: "5+",
      label: "BestSellers",
      icon: "BookOpen"
    },
    {
      number: "10+",
      label: "Premios y reconocimientos",
      icon: "Award"
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Stats Section */}
        <div className="text-center mb-16">
          <h2 className="font-headline text-3xl lg:text-4xl font-bold text-primary mb-4">
            Un Legado Literario Reconocido
          </h2>
          
          <p className="font-body text-lg text-scholarly-gray max-w-3xl mx-auto mb-12">
            Décadas de excelencia literaria respaldadas por lectores, críticos y académicos de todo el mundo.
          </p>

          <div className="grid grid-cols-2 lg:grid-cols-3 gap-8 justify-center">
            {stats?.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Icon name={stat?.icon} size={24} className="text-primary" />
                </div>
                <div className="font-headline text-3xl lg:text-4xl font-bold text-primary mb-2">
                  {stat?.number}
                </div>
                <div className="font-body text-sm text-scholarly-gray">
                  {stat?.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Awards Section
        <div className="mb-16">
          <div className="text-center mb-12">
            <div className="inline-flex items-center space-x-2 px-4 py-2 bg-accent/10 rounded-full mb-6">
              <Icon name="Award" size={16} className="text-accent" />
              <span className="font-accent text-sm font-medium text-accent">
                Reconocimientos
              </span>
            </div>
            
            <h3 className="font-headline text-2xl lg:text-3xl font-bold text-primary mb-4">
              Premios y Distinciones
            </h3>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {awards?.map((award, index) => (
              <div key={index} className="bg-card rounded-xl literary-shadow p-6 text-center">
                <div className="w-12 h-12 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Icon name="Trophy" size={24} className="text-accent" />
                </div>
                
                <h4 className="font-headline text-lg font-bold text-primary mb-2">
                  {award?.title}
                </h4>
                
                <div className="font-accent text-burnished-copper font-semibold mb-3">
                  {award?.year}
                </div>
                
                <p className="font-body text-sm text-foreground leading-relaxed">
                  {award?.description}
                </p>
              </div>
            ))}
          </div>
        </div>*/}
      </div>
    </section>
  );
};

export default SocialProofSection;